const contactCompany = document.querySelector("#company");
const contactEmail = document.querySelector("#email");
const contactSubject = document.querySelector("#subject");
const contactMessage = document.querySelector("#message");
const formLoading = document.querySelector("#formLoading");
const btnSubmit = document.querySelector("#btnSubmit");

let isLoading = false;

const validateForm = () => {};

const onSubmitHandler = async () => {
  isLoading = true;

  formLoading.textContent = "Enviando...";
  const formData = new FormData();
  formData.append("contact-company", contactCompany);
  formData.append("contact-email", contactEmail);
  formData.append("contact-subject", contactSubject);
  formData.append("contact-message", contactMessage);

  try {
    const response = await fetch(
      "/wp-content/themes/teknisa_three/src/php/contact.php",
      {
        method: "POST",
        body: formData,
      }
    );

    console.log(response.ok);
  } catch (error) {
    console.log(error);
  } finally {
    isLoading = false;
    formLoading.textContent = "";
  }
};

btnSubmit.addEventListener("click", (e) => {
  e.preventDefault();

  onSubmitHandler();
});
